<template>
  <div class="wrap-generate-audio" :class="{ 'wrap-generate-audio--disabled': disabled }">
    <div v-if="!isGenerating && !audioReadAloudLink" class="wrap-generate-audio__generate-btn" @click="handleGenerate">
      <div class="wrap-generate-audio__icon">
        <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.4284 18.5714L5.39556 13.4286H1V6.57151H5.39556L12.4284 1.42871V18.5714Z"
            fill="#007EFF"
            stroke="#007EFF"
            stroke-width="1.71427"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M16.2383 13.0306C17.5081 11.421 17.5081 8.92605 16.2383 7.31641V13.0306Z" fill="#007EFF" />
          <path
            d="M16.2383 13.0306C17.5081 11.421 17.5081 8.92605 16.2383 7.31641"
            stroke="#007EFF"
            stroke-width="2.28569"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.0957 15.7136C21.6354 12.564 21.6354 7.43473 19.0957 4.28516"
            stroke="#007EFF"
            stroke-width="2.28569"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="wrap-generate-audio__content-text">
        Generate audio
      </div>
    </div>
    <div v-if="isGenerating" class="wrap-generate-audio__generating">
      <div class="wrap-generate-audio__generating-text">
        <div class="wrap-generate-audio__generating-text-content">Generating...</div>
        <div class="wrap-generate-audio__generating-text-animation"></div>
      </div>
    </div>
    <div v-if="!!audioReadAloudLink" class="wrap-generate-audio__player">
      <audio ref="$audio" :src="audioFullLink" controls controlsList="nodownload noplaybackrate"></audio>
      <span class="wrap-generate-audio__player-delete-btn" @click="handleDeleteAudio">
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="52" height="52" rx="26" fill="#F1F3F4" />
          <mask
            id="mask0_43_3668"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="14"
            y="14"
            width="24"
            height="24"
          >
            <rect x="14" y="14" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_43_3668)">
            <path
              d="M21 35C20.45 35 19.9792 34.8042 19.5875 34.4125C19.1958 34.0208 19 33.55 19 33V20H18V18H23V17H29V18H34V20H33V33C33 33.55 32.8042 34.0208 32.4125 34.4125C32.0208 34.8042 31.55 35 31 35H21ZM31 20H21V33H31V20ZM23 31H25V22H23V31ZM27 31H29V22H27V31Z"
              fill="#1C1B1F"
            />
          </g></svg
      ></span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import axios from "@/utils/axios";

export default {
  props: {
    disabled: { type: Boolean, default: false },
    text: { type: String, default: "" },
  },
  data() {
    return {
      isGenerating: false,
      loadingDelete: null,
    };
  },
  methods: {
    ...mapActions("readAlouds", ["changeLinkAudio"]),
    async handleGenerate() {
      const orgId = this.$route.params && this.$route.params.organizationId;
      if (!this.text || !orgId) return;

      try {
        this.isGenerating = true;
        const res = await axios.post(
          `v1/homeworks/${orgId}/tts/`,
          {
            text: this.text,
          },
          {
            headers: {
              "x-session-token": localStorage.getItem("payment-token"),
              Authorization: null,
            },
          }
        );

        this.isGenerating = false;
        if (!res.data && !res.data.audio_url) {
          this.changeLinkAudio("");

          return;
        }
        this.changeLinkAudio(res.data.audio_url);
      } catch (error) {
        this.isGenerating = false;
        const msg = (error.response && error.response.data) || error || this.$t("common.generic_error_message");
        this.$message({
          showClose: true,
          message: msg,
          type: "error",
        });
      }
    },
    async handleDeleteAudio() {
      if (!this.audioReadAloudLink.includes("/tmp/")) {
        this.changeLinkAudio("");

        return;
      }
      const orgId = this.$route.params && this.$route.params.organizationId;
      if (!this.changeLinkAudio) return;
      const fileName = this.audioReadAloudLink.replace(/https?:\/\/(?:www\.)?([^/\s]+)\//, "");
      if (!fileName) return;
      try {
        this.loadingDelete = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        await axios.delete(
          `v1/homeworks/${orgId}/tts/`,
          {
            params: {
              file_name: fileName,
            },
          },
          {
            headers: {
              "x-session-token": localStorage.getItem("payment-token"),
              Authorization: null,
            },
          }
        );

        this.loadingDelete.close();
        this.changeLinkAudio("");
      } catch (error) {
        const msg = (error.response && error.response.data) || error || this.$t("common.generic_error_message");
        this.$message({
          showClose: true,
          message: msg,
          type: "error",
        });
        this.loadingDelete.close();
        this.changeLinkAudio("");
      }
    },
  },
  computed: {
    ...mapState("readAlouds", ["audioReadAloudLink", "audioSpeed"]),
    audioFullLink() {
      if (this.audioReadAloudLink.includes("http")) return this.audioReadAloudLink;

      return `${process.env.VUE_APP_PATH_S3_BUCKET}${this.audioReadAloudLink}`;
    },
  },
  watch: {
    audioReadAloudLink: {
      async handler() {
        await setTimeout(() => {}, 10);
        if (!this.$refs.$audio) return;
        this.$refs.$audio.playbackRate = this.audioSpeed;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-generate-audio {
  display: inline-block;
  max-height: 52px;
  max-width: 100%;
  overflow-y: hidden;
  &--disabled {
    .wrap-generate-audio {
      &__content-text {
        color: #fff;
      }
      &__generate-btn {
        background-color: rgba(109, 122, 140, 0.18);
      }
      &__icon {
        path {
          fill: #fff;
          stroke: #fff;
        }
      }
    }
  }
  &__generate-btn {
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: #007eff14;
    padding: 12px;
    border-radius: 100px;
    cursor: pointer;
  }
  &__icon {
    display: flex;
  }
  &__content-text {
    display: inline-block;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: #007eff;
  }

  &__generating {
    display: inline-block;
    border: 1.5px solid rgba(255, 122, 0, 0.3);
    border-radius: 100px;
    padding: 12px 37px;
    position: relative;
    overflow: hidden;
    min-width: 150px;

    &-text {
      display: inline-block;
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      color: rgba(9, 53, 98, 1);
      background-color: transparent;
      &-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }
      &-animation {
        height: 100%;
        background-color: rgba(255, 236, 218, 1);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        animation: left-animate 2s ease infinite;
      }
    }
  }
  @keyframes left-animate {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  &__player {
    display: flex;
    width: 100%;
    gap: 8px;
    height: 52px;
    overflow: hidden;

    audio {
      height: 52px;
      flex: 1;
    }

    &-delete-btn {
      display: inline-block;
      cursor: pointer;
    }
  }
}
</style>
